export default __webpack_public_path__ + "static/media/OpenWeatherApp.09ad206d.jpg";